"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIScanScheduleResponseSchema = exports.APIScanScheduleRequestSchema = exports.APIScanScheduleTimeValueSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("./enums");
// ===== SCHEMAS =====
exports.APIScanScheduleTimeValueSchema = zod_1.z.object({
    hour: zod_1.z.number().min(1).max(12),
    minute: zod_1.z.number().min(0).max(59),
    period: zod_1.z.enum(enums_1.timePeriodEnum),
});
exports.APIScanScheduleRequestSchema = zod_1.z.object({
    timezone: zod_1.z.string(),
    days: zod_1.z.array(zod_1.z.enum(enums_1.dayOfWeekEnum)).min(1, 'Please select at least one day'),
    time: exports.APIScanScheduleTimeValueSchema,
    /**
     * The habit the user anchors their daily scan to (e.g. `after_gym`). Optional
     * for backward compatibility with callers that don't capture it; persisted on
     * `scan_plan.reminder_anchor`. Not yet used for reminder copy.
     */
    anchor: zod_1.z.enum(enums_1.scanReminderAnchorEnum).optional(),
});
// ===== RESPONSES =====
exports.APIScanScheduleResponseSchema = zod_1.z.object({
    timezone: zod_1.z.string(),
    days: zod_1.z.array(zod_1.z.enum(enums_1.dayOfWeekEnum)),
    time: exports.APIScanScheduleTimeValueSchema,
});
//# sourceMappingURL=scan_schedule.js.map